import React, { useEffect, useState } from "react";
import "./CollaboratorPage.css";
import InfoCard from "../../components/ui/InfoCard/InfoCard";
import { FaUser } from "react-icons/fa";
import { study_membersService } from "../../service";
import Spinner from "../../components/ui/Spinner/Spinner";
import MembersDetails from "../../components/study_member/MembersDetails/MembersDetails";

const CollaboratorPage = () => {
  const [collaborators, setCollaborators] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [detailsView, setDetailsView] = useState("");
  const [selectedCollaborator, setSelectedCollaborator] = useState(null);
  const [selectedStudyId, setSelectedStudyId] = useState(null);

  // ---------------------------------------
  // FETCH COLLABORATORS + THEIR STUDY COUNTS
  // ---------------------------------------
  useEffect(() => {
    const fetchCollaborators = async () => {
      try {
        setLoading(true);
        setError("");

        const { data } = await study_membersService.getMyCollaborators();

        // Fetch study count for each collaborator
        const collaboratorsWithCounts = await Promise.all(
          data.map(async (collab) => {
            try {
              const res = await study_membersService.getInvestigatorStudyCount(
                collab.id
              );
              return { ...collab, studyCount: res.data.count };
            } catch {
              return { ...collab, studyCount: 0 };
            }
          })
        );

        setCollaborators(collaboratorsWithCounts);
      } catch (err) {
        console.error("Erreur lors du chargement:", err);
        setError("Impossible de charger vos collaborateurs.");
      } finally {
        setLoading(false);
      }
    };

    fetchCollaborators();
  }, []);

  // -------------------------------
  // OPEN DETAILS VIEW
  // -------------------------------
  const handleShowCollaboratorDetails = (collab) => {
    setSelectedCollaborator(collab);
    setSelectedStudyId(collab.study_id || collab.studyId);
    setDetailsView("details");
  };

  // -------------------------------
  // UI STATES
  // -------------------------------
  if (loading) return <Spinner size="lg" />;
  if (error)
    return <div className="alert alert-danger text-center mt-4">{error}</div>;

  return (
    <main className="content flex-grow-1 px-4 ms-2 mt-3 py-4">
      <div className="overflow-y-auto px-0" style={{ height: "100%" }}>
        <div className="container-fluid">

          {detailsView === "details" && selectedCollaborator ? (
            <MembersDetails
              studyId={selectedStudyId}
              investigatorId={selectedCollaborator.id}
              type="collaborator"
              onBack={() => setDetailsView("")}
            />
          ) : (
            <>
              {collaborators.length === 0 ? (
                <p className="text-center text-muted mt-5">
                  Aucun collaborateur trouvé.
                </p>
              ) : (
                <div className="row g-3 mt-2">
                  {collaborators.map((collab) => (
                    <div
                      className="col-12 col-sm-6 col-md-4 col-lg-3"
                      key={collab.id}
                    >
                      <InfoCard
                        title={`${collab.first_name} ${collab.last_name}`}
                        count={collab.studyCount}
                        unit="study"
                        Icon={FaUser}
                        actionType="Voir détails"
                        onClick={() => handleShowCollaboratorDetails(collab)}
                        onStatsClick={() => handleShowCollaboratorDetails(collab)}
                        showOptions={false}
                      />
                    </div>
                  ))}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </main>
  );
};

export default CollaboratorPage;
